export default {"src":"/_next/static/media/visibility-off.a5b564e0.svg","height":24,"width":24,"blurWidth":0,"blurHeight":0};